import { Module } from 'vuex'

const composeModule: Module<any, any> = {
  namespaced: true,

  state: () => ({
    context: '',
    query: '',
    composeResponse: {},
    betslipInfoResponse: {},
  }),

  mutations: {
    resetComposeStore(state) {
      state.context = ''
      state.query = ''
      state.composeResponse = {}
      state.betslipInfoResponse = {}
    },
    setContext(state, context) {
      state.context = context
    },

    setQuery(state, query) {
      state.query = query
    },

    setComposeResponse(state, composeResponse) {
      state.composeResponse = composeResponse
    },

    setBetslipInfoResponse(state, betslipInfoResponse) {
      state.betslipInfoResponse = betslipInfoResponse
    },
  },

  actions: {
    setContext({ commit, state, dispatch }, context) {
      if (state.context && state.context !== context) {
        commit('resetComposeStore')
      }
      commit('setContext', context)
    },

    setQuery({ commit }, query) {
      commit('setQuery', query)
    },

    setComposeResponse({ commit, getters }, composeResponse) {
      commit('setComposeResponse', composeResponse)
    },

    setBetslipInfoResponse({ commit, getters }, betslipInfoResponse) {
      commit('setBetslipInfoResponse', betslipInfoResponse)
    },
  },

  getters: {
    context(state) {
      return state.context
    },

    query(state) {
      return state.query
    },

    composeResponse(state) {
      return state.composeResponse
    },

    suggestions(state, getters) {
      return getters.composeResponse?.suggestions
    },

    resolutions(state, getters) {
      return getters.composeResponse?.resolutions
    },

    resolution(state, getters) {
      return getters.resolutions?.[0]
    },

    betslip(state, getters) {
      return getters.resolution?.betslip
    },

    formattedBetslip(state, getters) {
      return getters.betslip?.formatted
    },

    betslipInfoResponse(state) {
      return state.betslipInfoResponse
    },

    price(state, getters) {
      return getters.betslipInfoResponse?.price
    },

    formattedPrice(state, getters) {
      return getters.price?.formatted
    },

    deepLinkUrl(state, getters) {
      return getters.betslipInfoResponse?.deepLinkURL
    },
  },
}

export default composeModule
